/* eslint-disable max-lines */
import { selectUsers } from 'actions/userPermissionsPage';
import React from 'react';
import { useDispatch } from 'react-redux';
import { useRouteMatch } from 'react-router-dom';
import { getSelectedUsers } from 'selectors/userPermissionsPage';
import { getUsers, getUsersLoading } from 'selectors/users';
import { useSelector } from 'store';
import type { User } from 'types';
import userTypeMap from 'utils/usersListMap';
import EmptyUsersTable from './EmptyUsersTable';

const UserTable: React.FC = () => {
  const dispatch = useDispatch();
  const route = useRouteMatch();
  const userType = Object.entries(userTypeMap).find(
    ([k]) => route.path.split('/').pop() === k
  )?.[1];

  const users = useSelector(getUsers);
  const loading = useSelector(getUsersLoading);
  const selectedUsers = useSelector(getSelectedUsers);

  const handleSelectUser = (e: React.ChangeEvent<HTMLInputElement>, user: User): void => {
    e.stopPropagation();
    if (selectedUsers.find((u) => u.uuid === user.uuid)) {
      const sUsers = selectedUsers.filter((u) => u.uuid !== user.uuid);
      dispatch(selectUsers(sUsers));
    } else {
      dispatch(selectUsers([...selectedUsers, user]));
    }
  };

  if (!userType) return null;

  return (
    <table className="table-wrapper__table table-wrapper_table--fixed">
      {React.createElement(userType.headers)}
      <tbody className="table-wrapper__tbody" data-testid="users-table">
        {!loading && Object.keys(users).length === 0 ? (
          <EmptyUsersTable colCount={userType.colCount.toString()} />
        ) : (
          Object.values(users).map((user) =>
            React.createElement(userType.tableRow, {
              key: user.uuid,
              user,
              selectedUsers,
              handleSelectUser,
            })
          )
        )}
      </tbody>
    </table>
  );
};
export default UserTable;
